import { WizardLauncherService } from "../../wizard.launcher.service";
import { UserService } from "@nrwl/common-lib";
import { BaseWizardService } from "../../services/base.wizard.service";
import {
  Component,
  QueryList,
  ViewChildren,
  AfterViewInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  EventEmitter,
  ViewContainerRef,
  ComponentFactoryResolver,
  ViewEncapsulation
} from "@angular/core";
import { get } from 'lodash';
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { IWizardEntry } from "../../wizard.entry";
import { WizardComponent } from "../../wizard.component";
import { SitesDescHtmlComponent } from "./sites.desc.page/sites.desc.component";
import { SitesWizardService } from "../../services/sites/sites.wizard.service";
import { SitesLocationHtmlComponent } from "./sites.location.page/sites.location.component";
import { SitesSubnetHtmlComponent } from "./sites.subnets.page/sites.subnet.component";
import { SitesCreateHtmlComponent } from "./sites.review.page/sites.create.component";
import { SitesReviewSubContentCommponent } from "./sites.review.page/review.sub.content.component";
import { SitesCreateResultsHtmlComponent } from "./sites.final.page/sites.create.results.component";

@Component({
  selector: "new-site-wizard",
  providers: [
    SitesWizardService
  ],
  templateUrl: "../../wizard.template.html",
  styleUrls: ['../../wizard.component.style.scss', '../../wizard.button.style.scss', './wizard.sites.style.scss']
})
export class NewSiteWizardComponent extends WizardComponent implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
  wizardConfig: any;
  wizardId: string;
  dataId: any;
  onClose = new EventEmitter<any>();

  state: Router;
  wizardService: BaseWizardService;
  userService: UserService;
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;

  @ViewChild('contentPlaceholder', { read: ViewContainerRef,
static: true }) contentRef: ViewContainerRef;
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef,
static: true }) subContentRef: ViewContainerRef;

  // @ViewChildren("currentForm") currentStepForm: QueryList<NgForm>;

  constructor(
    state: Router,
    wizardService: SitesWizardService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly launcher: WizardLauncherService,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.state = state;
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.wizardService.editMode = this.wizardId === 'update_sites';
    this.wizardService.openWizard(this.wizardId, this.wizardConfig, this.dataId);
    this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.wizardService._setDefaultParams(this.wizardService.currentStep, this.wizardService.currentStep.output, this.wizardService.defaultParamsById);
    this.createContentComponent();
  }

  goToStep(stepName) {
    this.wizardService.goToStep(stepName);
    this.createContentComponent();
  }

  toggleFinish() {
    const wizardService = this.wizardService as SitesWizardService
    const result = wizardService.onFinish();
    result.subscribe(outcome => {
      this.notifyOnToggleSubContent(false);
      this.createContentComponent();
    });
  }

  retryOperation() {
    (this.wizardService as SitesWizardService).retrySaveRequest();
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    }
    else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }
  getFactoryResolver() {
    return this.factoryResolver;
  }
  getContentViewRef() {
    return this.contentRef;
  }
  getSubContentViewRef() {
    return this.subContentRef;
  }

  resolveComponentType(pageId) {
    switch (pageId) {
      case 'sites.desc.html':
        return SitesDescHtmlComponent;
      case 'sites.location.html':
        return SitesLocationHtmlComponent;
      case 'sites.subnet.html':
        return SitesSubnetHtmlComponent;
      case 'sites.create.html':
        return SitesCreateHtmlComponent;
      case 'review.sub.content.html':
        return SitesReviewSubContentCommponent;
      case 'sites.create.results.template.html': {
        return SitesCreateResultsHtmlComponent;
      }
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }

  }
}
